module.exports = __webpack_public_path__ + "img/bg.52c3620e.jpeg";